import { LOCALE } from '@strava/constants/src/appConstants';

export const sortImagesBySizeAndFormat =
  (sizeOrder, formatOrder) => (image1, image2) => {
    const { size: image1Size, format: image1Format } = image1;
    const { size: image2Size, format: image2Format } = image2;

    // Sort images by size
    if (sizeOrder.indexOf(image1Size?.id) > sizeOrder.indexOf(image2Size?.id)) {
      return 1;
    }

    if (sizeOrder.indexOf(image1Size?.id) < sizeOrder.indexOf(image2Size?.id)) {
      return -1;
    }

    // Sort images by format
    if (formatOrder.indexOf(image1Format) > formatOrder.indexOf(image2Format)) {
      return 1;
    }

    if (formatOrder.indexOf(image1Format) < formatOrder.indexOf(image2Format)) {
      return -1;
    }

    return 0;
  };

export const getImageLocaleDirectory = (locale, defaultDirectory) => {
  if (!locale) {
    return defaultDirectory;
  }

  return Object.values(LOCALE).includes(locale) ? locale : LOCALE.enUS;
};

export const getImageLocale = (locale) => {
  if (!locale) {
    return null;
  }

  return Object.values(LOCALE).includes(locale) ? locale : LOCALE.enUS;
};

export default {
  getImageLocaleDirectory,
  getImageLocale,
  sortImagesBySizeAndFormat
};
